import {
  Accordion as ChakraAccordion,
  AccordionItem as ChakraAccordionItem,
  AccordionButton as ChakraAccordionButton,
  AccordionPanel as ChakraAccordionPanel,
  AccordionIcon as ChakraAccordionIcon,
  Box,
} from '@chakra-ui/react'

interface InfoAccordionProps {
  items: React.ReactNode,
  className: string,
}

export function InfoAccordion({ items, className }: InfoAccordionProps) {
  return (
    <ChakraAccordion
      allowMultiple
      display="grid"
      gridTemplateColumns={{ base: '1fr', md: '1fr 1fr' }}
      gridGap="24px"
      className={className}
      borderWidth="0"
    >
      {items}
    </ChakraAccordion>
  );
}

interface InfoAccordionItemProps {
  buttonContent: React.ReactNode,
  panelContent: React.ReactNode,
  className?: string,
}

export function InfoAccordionItem({ buttonContent, panelContent, className }: InfoAccordionItemProps) {
  return (
    <Box>
      <ChakraAccordionItem className={className} borderWidth="0">
        <ChakraAccordionButton
          _hover={{ backgroundColor: "transparent" }}
          _groupHover={{ backgroundColor: "transparent" }}
          borderWidth="0"
        >
          {buttonContent}
          <ChakraAccordionIcon />
        </ChakraAccordionButton>
        <ChakraAccordionPanel borderWidth="0">
          {panelContent}
        </ChakraAccordionPanel>
      </ChakraAccordionItem>
    </Box>
  );
}
